const JOB_TYPE = {
  JOB: 1,
  INTERNSHIP: 2,
  SCHOOL: 3,
  GRADUATION: 4,
};

export default JOB_TYPE;
